module.exports = __webpack_public_path__ + "img/JOC_3513.2b564579.jpg";